"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImportApiClient = createImportApiClient;
const axios_client_1 = require("@invivodf/axios-client");
function createImportApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function asyncImport(params) {
        const formData = new FormData();
        formData.append('file', params.file);
        await client.post(`/backoffice/v2/import/partners/${params.partnerId}/${params.importDomain}`, formData, {
            params: params.taskId,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
    return {
        asyncImport
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wb3J0LmNsaWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbXBvcnQvaW1wb3J0LmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU9BLHNEQWtCQztBQXhCRCx5REFBOEU7QUFNOUUsU0FBZ0IscUJBQXFCLENBQUMsT0FBZSxFQUFFLE9BQTJCO0lBRWhGLE1BQU0sTUFBTSxHQUFHLElBQUEsZ0NBQWlCLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBRWxELEtBQUssVUFBVSxXQUFXLENBQUMsTUFBNEM7UUFDckUsTUFBTSxRQUFRLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztRQUNoQyxRQUFRLENBQUMsTUFBTSxDQUFDLE1BQU0sRUFBRSxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDckMsTUFBTSxNQUFNLENBQUMsSUFBSSxDQUFDLGtDQUFrQyxNQUFNLENBQUMsU0FBUyxJQUFJLE1BQU0sQ0FBQyxZQUFZLEVBQUUsRUFBRSxRQUFRLEVBQUU7WUFDdkcsTUFBTSxFQUFFLE1BQU0sQ0FBQyxNQUFNO1lBQ3JCLE9BQU8sRUFBRTtnQkFDUCxjQUFjLEVBQUUscUJBQXFCO2FBQ3RDO1NBQ0YsQ0FBQyxDQUFBO0lBQ0osQ0FBQztJQUVELE9BQU87UUFDTCxXQUFXO0tBQ1osQ0FBQTtBQUNILENBQUMifQ==